<template>
    <nav class="navbar navbar-expand-lg navbar-light bg-white">
        <div class="container">
            <a class="navbar-brand" href="/">
                <img alt="..." class="navbar-brand-img" height="65" src="../assets/img/Truvito.svg" width="300">
            </a>

            <button aria-controls="navbarCollapse" aria-expanded="false" aria-label="Toggle navigation" class="navbar-toggler" data-target="#navbarCollapse" data-toggle="collapse" type="button">
                <span class="navbar-toggler-icon"/>
            </button>

            <div class="collapse navbar-collapse" id="navbarCollapse">
                <button aria-controls="navbarCollapse" aria-expanded="false" aria-label="Toggle navigation" class="navbar-toggler" data-target="#navbarCollapse" data-toggle="collapse" type="button">
                    <i class="fe fe-x"/>
                </button>

                <ul class="navbar-nav ml-auto">
                    <li class="nav-item dropdown">
                        <a aria-expanded="false" aria-haspopup="true" class="nav-link dropdown-toggle" data-toggle="dropdown" href="#" id="navbarProducts">
                            Products
                        </a>
                        <div aria-labelledby="navbarProducts" class="dropdown-menu dropdown-menu-md">
                            <div class="list-group list-group-flush">
                                <router-link :to="{name: 'products', params: {id: 'truvito'}}" class="list-group-item">
                                    <div class="icon icon-sm text-success">
                                        <img alt="..." height="50" src="../assets/img/TruVito_.png" width="50">
                                    </div>
                                    <div class="ml-4">
                                        <h6 class="font-weight-bold text-uppercase text-success mb-0">
                                            TruVito
                                        </h6>
                                        <p class="font-size-sm text-gray-700 mb-0">
                                            Sustainability audits
                                        </p>
                                    </div>
                                </router-link>
                                <router-link :to="{name: 'products', params: {id: 'farmcare'}}" class="list-group-item">
                                    <div class="icon icon-sm text-success">
                                        <img alt="..." height="50" src="../assets/img/Farm-Care.png" width="50">
                                    </div>
                                    <div class="ml-4">
                                        <h6 class="font-weight-bold text-uppercase text-success mb-0">
                                            FarmCare
                                        </h6>
                                        <p class="font-size-sm text-gray-700 mb-0">
                                            Full suite of components for farmers
                                        </p>
                                    </div>
                                </router-link>
                                <router-link :to="{name: 'products', params: {id: 'trace'}}" class="list-group-item">
                                    <div class="icon icon-sm text-success">
                                        <img alt="..." height="50" src="../assets/img/TruVito-Trace.png" width="50">
                                    </div>
                                    <div class="ml-4">
                                        <h6 class="font-weight-bold text-uppercase text-success mb-0">
                                            TruVito Trace
                                        </h6>
                                        <p class="font-size-sm text-gray-700 mb-0">
                                            Keep track of products in supply chain
                                        </p>
                                    </div>
                                </router-link>
                            </div>
                        </div>
                    </li>
                    <li class="nav-item dropdown">
                        <a aria-expanded="false" aria-haspopup="true" class="nav-link dropdown-toggle" data-toggle="dropdown" href="#" id="navbarPages">
                            Company
                        </a>
                        <div aria-labelledby="navbarPages" class="dropdown-menu dropdown-menu-lg">
                            <div class="row no-gutters">
                                <div class="col-6 col-lg-4">
                                    <h6 class="dropdown-header">Company</h6>
                                    <router-link :to="{name: 'about'}" class="dropdown-item">About</router-link>
                                    <router-link :to="{name: 'media'}" class="dropdown-item">Media</router-link>
                                    <a class="dropdown-item mb-5" href="https://medium.com/truvito" target="_blank">Blog</a>
                                </div>
                                <div class="col-6 col-lg-4">
                                    <h6 class="dropdown-header">Resources</h6>
                                    <router-link :to="{name: 'terms'}" class="dropdown-item">Terms</router-link>
                                    <router-link :to="{name: 'privacy'}" class="dropdown-item mb-5 mb-lg-0">Privacy</router-link>
                                </div>
                                <div class="col-6 col-lg-4">
                                    <h6 class="dropdown-header">Contact</h6>
                                    <router-link :to="{name: 'salesenquiry'}" class="dropdown-item">Sales</router-link>
                                    <router-link :to="{name: 'contact'}" class="dropdown-item mb-5">General Inquiries</router-link>
                                </div>
                            </div>
                        </div>
                    </li>
                    <li class="nav-item">
                        <router-link :to="{name: 'sales'}" aria-expanded="false" aria-haspopup="true" class="nav-link" id="navbarSales">
                            Sales
                        </router-link>
                    </li>
                    <li class="nav-item dropdown">
                        <a aria-expanded="false" aria-haspopup="true" class="nav-link dropdown-toggle" data-toggle="dropdown" href="#" id="navbarDocumentation">
                            Developers
                        </a>
                        <div aria-labelledby="navbarDocumentation" class="dropdown-menu dropdown-menu-md">
                            <div class="list-group list-group-flush">
                                <a class="list-group-item" href="https://docs.borlaug.services/" target="_blank">
                                    <div class="icon icon-sm text-success">
                                        <svg height="24px" version="1.1" viewBox="0 0 24 24" width="24px" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                            <g fill="none" fill-rule="evenodd" id="Stockholm-icons-/-Layout-/-Layout-4-blocks" stroke="none" stroke-width="1">
                                                <rect height="24" id="bound" width="24" x="0" y="0"/>
                                                <rect fill="#335EEA" height="7" id="Rectangle-7" rx="1.5" width="7" x="4" y="4"/>
                                                <path d="M5.5,13 L9.5,13 C10.3284271,13 11,13.6715729 11,14.5 L11,18.5 C11,19.3284271 10.3284271,20 9.5,20 L5.5,20 C4.67157288,20 4,19.3284271 4,18.5 L4,14.5 C4,13.6715729 4.67157288,13 5.5,13 Z M14.5,4 L18.5,4 C19.3284271,4 20,4.67157288 20,5.5 L20,9.5 C20,10.3284271 19.3284271,11 18.5,11 L14.5,11 C13.6715729,11 13,10.3284271 13,9.5 L13,5.5 C13,4.67157288 13.6715729,4 14.5,4 Z M14.5,13 L18.5,13 C19.3284271,13 20,13.6715729 20,14.5 L20,18.5 C20,19.3284271 19.3284271,20 18.5,20 L14.5,20 C13.6715729,20 13,19.3284271 13,18.5 L13,14.5 C13,13.6715729 13.6715729,13 14.5,13 Z"
                                                      fill="#335EEA" id="Combined-Shape" opacity="0.3"/>
                                            </g>
                                        </svg>
                                    </div>
                                    <div class="ml-4">
                                        <h6 class="font-weight-bold text-uppercase text-success mb-0">
                                            API Reference
                                        </h6>
                                        <p class="font-size-sm text-gray-700 mb-0">
                                            REST API
                                        </p>
                                    </div>
                                </a>
                                <router-link :to="{name: 'changelog'}" class="list-group-item">
                                    <div class="icon icon-sm text-success">
                                        <svg height="24px" version="1.1" viewBox="0 0 24 24" width="24px" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                            <g fill="none" fill-rule="evenodd" id="Stockholm-icons-/-Files-/-File" stroke="none" stroke-width="1">
                                                <polygon id="Shape" points="0 0 24 0 24 24 0 24"/>
                                                <path d="M5.85714286,2 L13.7364114,2 C14.0910962,2 14.4343066,2.12568431 14.7051108,2.35473959 L19.4686994,6.3839416 C19.8056532,6.66894833 20,7.08787823 20,7.52920201 L20,20.0833333 C20,21.8738751 19.9795521,22 18.1428571,22 L5.85714286,22 C4.02044787,22 4,21.8738751 4,20.0833333 L4,3.91666667 C4,2.12612489 4.02044787,2 5.85714286,2 Z"
                                                      fill="#335EEA" id="Combined-Shape" opacity="0.3"/>
                                                <rect fill="#335EEA" height="2" id="Rectangle" rx="1" width="9" x="6" y="11"/>
                                                <rect fill="#335EEA" height="2" id="Rectangle-Copy" rx="1" width="5" x="6" y="15"/>
                                            </g>
                                        </svg>
                                    </div>
                                    <div class="ml-4">
                                        <h6 class="font-weight-bold text-uppercase text-success mb-0">
                                            Changelog
                                        </h6>
                                        <p class="font-size-sm text-gray-700 mb-0">
                                            Latest Release
                                        </p>
                                    </div>
                                    <span class="badge badge-pill badge-primary-soft ml-auto">20.07.2</span>
                                </router-link>
                            </div>
                        </div>
                    </li>
                    <!--                    <li class="nav-item">-->
                    <!--                        <a class="nav-link" id="navbarAccount" href="https://community.truvito.io" aria-haspopup="true" aria-expanded="false">-->
                    <!--                            Community-->
                    <!--                        </a>-->
                    <!--                    </li>-->
                </ul>

                <a class="navbar-btn btn btn-sm btn-success lift ml-auto" href="https://app.truvito.io" target="_blank">
                    Sign In
                </a>
            </div>
        </div>
    </nav>

</template>

<script>
    export default {
        name: "MainMenu"
    }
</script>

<style scoped>
    .navbar-expand-lg .navbar-nav .nav-link {
        padding-right: 1rem !important;
        padding-left: 1rem !important;
    }

    .navbar-brand-img {
        max-height: 1.9rem !important;
        width: auto;
    }

    .navbar-brand {
        margin-right: 0 !important;
    }

</style>
